//src/Hooks/useVerifyOTP.js
import { useRef, useState } from "react";
import React from "react";
import { confirmOTP, registerUser, sendOTP } from "../../API";

export default function useVerifyOTP({ formData, onSuccess }) {
  const inputs = useRef([...Array(6)].map(() => React.createRef()));
  const [error, setError] = useState("");
  const [resendError, setResendError] = useState("");
  const [resendSuccess, setResendSuccess] = useState("");
  const [resending, setResending] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  const handleChange = (e, idx) => {
    if (e.target.value.length === 1 && idx < 5) {
      inputs.current[idx + 1].current.focus();
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData('text').slice(0, 6);
    paste.split('').forEach((char, idx) => {
      if (inputs.current[idx].current) {
        inputs.current[idx].current.value = char;
      }
    });
    e.preventDefault();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otp_code = inputs.current.map(input => input.current.value).join("");
    try {
      const purpose = formData?.purpose || "register";
      await confirmOTP({ ...formData, otp_code, purpose });
      if (purpose === "register") {
        await registerUser({ ...formData, otp_code });
      }
      if (onSuccess) onSuccess(otp_code);
    } catch (err) {
      let msg = "فشل التحقق من الرمز أو انتهاء صلاحيته.";
      if (err.response && err.response.data) {
        if (typeof err.response.data === "string") {
          msg = err.response.data;
        } else if (typeof err.response.data === "object") {
          msg = Object.values(err.response.data).flat().join("، ");
        }
      }
      setError(msg);
    }
  };

  const handleResend = async () => {
    if (cooldown > 0 || resending) return;
    try {
      setResending(true);
      setResendError("");
      setResendSuccess("");
      const purpose = formData?.purpose || "register";
      await sendOTP({ phone_number: formData.phone_number, purpose });
      setResendSuccess("تم إرسال رمز التحقق بنجاح!");
      setCooldown(60);
      const interval = setInterval(() => {
        setCooldown((c) => {
          if (c <= 1) {
            clearInterval(interval);
            return 0;
          }
          return c - 1;
        });
      }, 1000);
    } catch (err) {
      let msg = "فشل إرسال رمز OTP. تحقق من الرقم أو الشبكة.";
      if (err?.response && err.response.data) {
        if (typeof err.response.data === "string") {
          msg = err.response.data;
        } else if (typeof err.response.data === "object") {
          try {
            msg = Object.values(err.response.data).flat().join("، ");
          } catch (_) {
            msg = JSON.stringify(err.response.data);
          }
        }
      }
      setResendError(msg);
    } finally {
      setResending(false);
    }
  };

  return {
    inputs: inputs.current,
    handleChange,
    handlePaste,
    handleSubmit,
    handleResend,
    error,
    resending,
    cooldown,
    resendError,
    resendSuccess
  };
} 
